var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2007",
    d: "M0-682.665H17.5v17.5H0Z",
    transform: "translate(0 682.665)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_41270",
    "data-name": "Group 41270",
    transform: "translate(-1021 -873)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_15665",
    "data-name": "Rectangle 15665",
    width: 20,
    height: 20,
    transform: "translate(1021 873)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g2001",
    transform: "translate(1022.25 874.25)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2003"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2005",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2011",
    transform: "translate(0.684 0.684)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2013",
    d: "M-306.6-613.2a8.066,8.066,0,0,1-8.066-8.066,8.066,8.066,0,0,1,8.066-8.066,8.066,8.066,0,0,1,8.066,8.066A8.066,8.066,0,0,1-306.6-613.2Z",
    transform: "translate(314.666 629.332)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2015",
    transform: "translate(5.879 10.835)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2017",
    d: "M0,0A3.718,3.718,0,0,0,2.871,1.641,3.718,3.718,0,0,0,5.742,0",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2019",
    transform: "translate(4.888 5.64)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2021",
    d: "M-227.351-32.479a.854.854,0,0,0,.854.854.854.854,0,0,0,.854-.854.854.854,0,0,0-.854-.854.854.854,0,0,0-.854.854m-5.127-.854a.854.854,0,0,1,.854.854.854.854,0,0,1-.854.854.854.854,0,0,1-.854-.854.854.854,0,0,1,.854-.854",
    transform: "translate(233.333 33.333)",
    fill: "currentColor"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmile);
export default __webpack_public_path__ + "static/media/smile.ba8f28dbc6712b3e46e9e8dd4e20760d.svg";
export { ForwardRef as ReactComponent };